import { render, staticRenderFns } from "./ImageLoader.vue?vue&type=template&id=c455505e&scoped=true"
import script from "./ImageLoader.vue?vue&type=script&lang=js"
export * from "./ImageLoader.vue?vue&type=script&lang=js"
import style0 from "./ImageLoader.vue?vue&type=style&index=0&id=c455505e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c455505e",
  null
  
)

export default component.exports